import UAParser from 'ua-parser-js';
const uaParser = new UAParser();
const browser = uaParser.getBrowser();
const withHttps = (str) => {
    if (str.startsWith('http://')) {
        return str.replace(/http:\/\//g, 'https://');
    }
    else if (str.startsWith('https://')) {
        return str;
    }
    return `https://${str}`;
};
const withoutEndingSlash = (str) => str.replace(/\/$/, '');
export const getAuth0ClientOptions = (config) => {
    let opt = {
        client_id: config.clientId,
        domain: config.domain,
        audience: withoutEndingSlash(withHttps(config.audience)),
        scope: config.scope,
        redirect_uri: config.redirectUri || window.location.origin,
        response_type: 'id_token token',
        leeway: 60,
        cacheLocation: ['Safari', 'Firefox'].includes(browser.name) ? 'localstorage' : 'memory',
    };
    if (config.additionalConfig) {
        opt = {
            ...opt,
            ...config.additionalConfig,
        };
    }
    return opt;
};
export const extractAuthProps = (user, config, token) => {
    if (!user) {
        return null;
    }
    const configStripped = withoutEndingSlash(config.audience);
    const metadata = user[`${configStripped}/app_metadata`];
    if (!metadata) {
        return null;
    }
    return {
        userId: metadata.userId,
        companyId: metadata.companyId,
        token,
    };
};
export const onRedirectCallback = (appState) => {
    window.history.replaceState({}, document.title, appState && appState.targetUrl ? appState.targetUrl : window.location.pathname);
};
export const storeOriginalRequest = (clientId) => {
    const fullUrl = withoutEndingSlash(window.location.href);
    const baseUrl = withoutEndingSlash(window.location.origin);
    if (!window.localStorage) {
        return;
    }
    const redirectKey = `${clientId}_shouldRedirectTo`;
    if (fullUrl !== baseUrl && !window.localStorage.getItem(redirectKey)) {
        window.localStorage.setItem(redirectKey, fullUrl);
    }
};
export const doStoredRequest = (clientId) => {
    if (!window.localStorage) {
        return;
    }
    const redirectKey = `${clientId}_shouldRedirectTo`;
    const url = window.localStorage.getItem(redirectKey);
    if (url) {
        window.localStorage.removeItem(redirectKey);
        window.location.href = url;
    }
};
const errorStrings = [
    'Expiration Time (exp) claim error in the ID token;',
    'Issued At (iat) claim error in the ID token;',
    "Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet.",
];
export const isTimingError = (error) => {
    const err = errorStrings.find((x) => error.message.startsWith(x));
    return !!err;
};
export const getCorrectTime = (success) => {
    const url = 'https://timeapi.herokuapp.com/utc/now.json';
    const ud = 'json' + +new Date();
    window[ud] = function (o) {
        success && success(new Date(o.dateString));
    };
    document.getElementsByTagName('head')[0].appendChild((function () {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.src = `${url}?callback=${ud}`;
        return s;
    })());
};
//# sourceMappingURL=authUtils.js.map